
import type { ContentType } from "@ca.vmedia.tv/domains";
export class StreamRequest {
    constructor(readonly id: number, readonly type: ContentType, readonly isRestart: boolean) {}
}